// extracted by mini-css-extract-plugin
export default {"tagWrapper":"TagItem_tagWrapper__28dap","tagWrapper__title":"TagItem_tagWrapper__title__vGOXL","tagWrapper__icon":"TagItem_tagWrapper__icon__H58ys"};